import React, { useEffect, useRef, useState } from 'react';
import { Breadcrumb, Button, message, Spin } from 'antd';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import logo from '../../assets/nubit.png';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getRequest } from '../../utils/APICall';
import moment from 'moment';
import {
  HomeIcon,
  DocumentChartBarIcon,
} from '@heroicons/react/16/solid';
import { useSelector } from 'react-redux';

const IndividualPayslip = () => {
  const [searchparams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [individualReportData, setIndividualReportData] = useState(null);
  const [leaveData, setleaveData] = useState(null);
  const payslipRef = useRef();
  // console.log("in", individualReportData)
  // console.log("leaveData", leaveData)
  const navigate = useNavigate();
  const fetchLeaveSummary = async (empId, fromDate, toDate) => {
    try {
      setLoading(true)
      const res = await getRequest(
        `getLeavesummary/${empId}?fromdate=${fromDate}&todate=${toDate}`
      );
      // console.log("response",res)
      setleaveData(res?.data)
      setLoading(false)
    } catch (error) {
      console.log("error", error)
      setLoading(false)

    }
  }

  useEffect(() => {
    const getmonth = searchparams.get("month");
    const getyear = searchparams.get("year") || new Date().getFullYear();
    const getEmpId = searchparams.get("empid");

    if (getmonth && getEmpId) {
      const month = parseInt(getmonth); // e.g. 5 for May
      const fromDate = moment(`${getyear}-${month}-01`);
      const toDate = moment(fromDate).endOf("month");

      const formattedFrom = fromDate.format("DD-MM-YYYY");
      const formattedTo = toDate.format("DD-MM-YYYY");

      fetchLeaveSummary(getEmpId, formattedFrom, formattedTo);
    }
    const getPayslipReport = async () => {
      const res = await getRequest(`empPayslip?month=${getmonth}&year=${getyear}&empid=${getEmpId}`);
      if (res?.success) {
        setIndividualReportData(res?.data);
      } else {
        message.warning('This payslip does not exist');
        navigate('/payslip');
      }
      setLoading(false);
    };
    if (getmonth && getyear && getEmpId) {
      getPayslipReport();
    } else {
      message.warning('Missing month, year or empid in URL');
      navigate('/payslip');
    }
  }, [searchparams?.get("month"), searchparams?.get("year"), searchparams?.get("empid")]);

  const { users } = useSelector((state) => state.user || {});
  const numberToWords = (num) => {
    if (num === null || num === undefined) return '';
    const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
      'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
      'Seventeen', 'Eighteen', 'Nineteen'];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const inWords = (n) => {
      if (n < 20) return a[n];
      if (n < 100) return b[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + a[n % 10] : '');
      if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' and ' + inWords(n % 100) : '');
      if (n < 1000000) return inWords(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 !== 0 ? ' ' + inWords(n % 1000) : '');
      return n;
    };
    return inWords(Number(num));
  };

  // useEffect(() => {
  //   const getPayslipReport = async () => {
  //     const res = await getRequest(`empPayslip?month=${getmonth}&year=${getyear}&empid=${getEmpId}`);
  //     if (res?.success) {
  //       setIndividualReportData(res?.data);
  //     } else {
  //       message.warning('This payslip does not exist');
  //       navigate('/payslip');
  //     }
  //     setLoading(false);
  //   };
  //   if (getmonth && getyear && getEmpId) {
  //     getPayslipReport();
  //   } else {
  //     message.warning('Missing month, year or empid in URL');
  //     navigate('/payslip');
  //   }
  // }, [getmonth, getyear, getEmpId]);
  // console.log(users?.ROLE_TITLE !== "HR"  || users?.ROLE_TITLE !== "Admin")
  // useEffect(() => {
  //   if (!users) return;

  //   if (users.ROLE_TITLE !== "HR" && users.ROLE_TITLE !== "Admin") {
  //     navigate("/login");
  //   }
  // }, [users]);
  const handleGeneratePDF = async () => {
    const element = payslipRef.current;
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      scrollX: 0,
      scrollY: -window.scrollY,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight
    });
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`Payslip_${individualReportData?.firstname}_${individualReportData?.monthname}.pdf`);
  };

  const totalEarnings = individualReportData?.salaryHead?.reduce((acc, item) => acc + (parseFloat(item.earning) || 0), 0);
  const totalDeduction = individualReportData?.salaryHead?.reduce((acc, item) => acc + (parseFloat(item.deduction) || 0), 0);
  const totalnum = (totalEarnings || 0) - (totalDeduction || 0);

  const items = [
    {
      href: '/',
      title: (
        <span className="flex gap-2 items-center">
          <HomeIcon className="h-6 w-6 text-gray-500" />
          <span className="text-gray-400 sm:text-lg  md:text-xl font-black">Home</span>
        </span>
      ),
    },
    {
      href: '/payslip',
      title: (
        <span className="flex gap-2 items-center">
          <DocumentChartBarIcon className="h-6 w-6 text-gray-300" />
          <span className="text-gray-400 sm:text-lg  md:text-xl font-black">Pay Slip</span>
        </span>
      ),
    },
  ];

  return (
    <>
      <div className="p-2 md:px-6 pt-10">
        <Breadcrumb items={items} />
      </div>

      {loading ? (
        <div className="flex justify-center items-center min-h-[60vh]">
          <Spin size="large" />
        </div>
      ) : (
        <div className="bg-white shadow-md rounded-md p-4 md:px-6">
          <div className="pb-12">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Payslip Report</h2>
              <img src={logo} alt="Logo" className="w-24 md:w-32" />
            </div>

            <div ref={payslipRef} className="p-4 md:p-10 bg-white max-w-4xl mx-auto shadow-md border">
              <div className="flex justify-between items-center border-b pb-4">
                <img src={logo} alt="Logo" className="w-24 md:w-32" />
                <div className="text-center">
                  <h2 className="font-bold text-xl md:text-2xl">SALARY SLIP</h2>
                  <p className="text-sm font-semibold">{individualReportData?.monthname}</p>
                </div>
                <div className="text-right font-bold text-lg text-gray-700">CONFIDENTIAL</div>
              </div>

              {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6 text-sm">
                <div className="space-y-1">
                  <p><strong>Employee ID:</strong> {individualReportData?.empid}</p>
                  <p><strong>Name:</strong> {individualReportData?.firstname}</p>
                </div>
                <div className="space-y-1">
                  <p><strong>Designation:</strong> {individualReportData?.designation}</p>
                  <p><strong>Cheque No:</strong> {individualReportData?.chequeno}</p>
                </div>
                <div className="space-y-1  ">
                  <p><strong>Annual:</strong> {leaveData && leaveData[0]?.TAKEN}</p>
                  <p><strong>Sick:</strong> {leaveData && leaveData[1]?.TAKEN}</p>
                  <p><strong>Absent:</strong> {leaveData && leaveData[2]?.TAKEN}</p>
                </div>
              </div> */}
              <div className="overflow-x-auto mt-6">
                <table className="table-auto border-collapse border border-gray-300 text-xs sm:text-sm w-full min-w-[600px]">
                  <thead>
                    <tr>
                      <th className="border px-2 py-1">Employee ID</th>
                      <th className="border px-2 py-1">Name</th>
                      <th className="border px-2 py-1">Designation</th>
                      <th className="border px-2 py-1">Cheque No</th>
                      <th className="border px-2 py-1">Annual Leave</th>
                      <th className="border px-2 py-1">Sick Leave</th>
                      <th className="border px-2 py-1">Absent</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border px-2 py-1">{individualReportData?.empid}</td>
                      <td className="border px-2 py-1">{individualReportData?.firstname}</td>
                      <td className="border px-2 py-1">{individualReportData?.designation}</td>
                      <td className="border px-2 py-1">{individualReportData?.chequeno}</td>
                      <td className="border px-2 py-1 text-center">{leaveData?.[0]?.TAKEN}</td>
                      <td className="border px-2 py-1 text-center">{leaveData?.[1]?.TAKEN}</td>
                      <td className="border px-2 py-1 text-center">{leaveData?.[2]?.TAKEN}</td>
                    </tr>
                  </tbody>
                </table>
              </div>


              <div className="mt-6 overflow-x-auto">
                <table className="w-full  text-xs sm:text-sm border-collapse border min-w-[400px]">
                  <thead>
                    <tr className="bg-blue-900 text-white">
                      <th className="border px-2 py-1 text-left">Description</th>
                      <th className="border px-2 py-1 text-right">Earnings</th>
                      <th className="border px-2 py-1 text-right">Deductions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {individualReportData?.salaryHead
                      ?.filter(item => item.earning)
                      .concat(individualReportData?.salaryHead?.filter(item => item.deduction))
                      .map((item, idx) => (
                        <tr key={`item-${idx}`}>
                          <td className="border px-2 py-1">{item.head}</td>
                          <td className="border px-2 py-1 text-right">{item?.earning?.toLocaleString('en-US') || '-'}</td>
                          <td className="border px-2 py-1 text-right">{item?.deduction?.toLocaleString('en-US') || '-'}</td>
                        </tr>
                      ))}
                  </tbody>
                  <tfoot>
                    <tr className="font-bold">
                      <td className="border px-2 py-1 text-right">Total</td>
                      <td className="border px-2 py-1 text-right">{totalEarnings?.toLocaleString('en-US')}</td>
                      <td className="border px-2 py-1 text-right">{totalDeduction?.toLocaleString('en-US')}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 mt-6 text-sm">
                <div className="space-y-1">
                  <p><strong>Payment Date:</strong> {moment(individualReportData?.paydate).format("DD-MMMM-YYYY")}</p>
                  <p><strong>Bank Name:</strong> {individualReportData?.bankname}</p>
                  <p><strong>Bank Account Name:</strong> {individualReportData?.bankaccounttitle}</p>
                  <p><strong>Bank Account #:</strong> {individualReportData?.accountno}</p>
                </div>
                <div className="text-right">
                  <div className="bg-blue-900 text-white py-1 font-bold">NET PAY</div>
                  <div className="bg-gray-200 font-bold text-2xl py-2">{totalnum?.toLocaleString('en-US')}</div>
                  <div className="italic text-[12px] font-mono mt-1">{numberToWords(totalnum)} Rupees</div>
                </div>
              </div>
            </div>

            <div className="text-center mt-6">
              <Button
                type="primary"
                className="bg-blue-900 hover:bg-blue-700"
                onClick={handleGeneratePDF}
              >
                Generate PDF
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default IndividualPayslip;